var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { WalletType } from '@cta-portal/webapp-common/lib/api/schema';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useContext, useEffect, useState } from 'react';
import { DialogContext } from '../../context/dialog';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { WalletConnectionType } from '../../types/blockchain';
import { DialogType } from '../../types/dialogs';
import { sleep } from '../../utils/async';
import { useImxActions } from '../imx/use-imx-actions';
export var EBurnStatus;
(function (EBurnStatus) {
    EBurnStatus["NONE"] = "NONE";
    EBurnStatus["PENDING"] = "PENDING";
    EBurnStatus["READY"] = "READY";
    EBurnStatus["PROCESSING"] = "PROCESSING";
    EBurnStatus["COMPLETED"] = "COMPLETED";
})(EBurnStatus || (EBurnStatus = {}));
export function usePendingBurn(pendingBurnUuid) {
    var t = useI18n().t;
    var _a = useContext(LoadingContext), serverLoading = _a.serverLoading, setServerLoading = _a.setServerLoading;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var user = useContext(UserContext).user;
    var _b = useState(undefined), pendingBurnState = _b[0], setPendingBurnState = _b[1];
    var _c = useState(undefined), pendingBurnStatusMagicLink = _c[0], setPendingBurnStatusMagicLink = _c[1];
    var _d = useState(undefined), pendingBurnStatusMetamask = _d[0], setPendingBurnStatusMetamask = _d[1];
    var _e = useState(undefined), pendingBurnStatusMpc = _e[0], setPendingBurnStatusMpc = _e[1];
    var imxActions = useImxActions();
    useEffect(function () {
        function init() {
            return __awaiter(this, void 0, void 0, function () {
                var blockchainPendingBurnFindOneWithEmail, magicLinkEmail, tokenAddress, _a, tokenIdsToBurn, tokenIdsBurned_1, tokenIdsToBurnMagicLink, tokenIdsToBurnMetamask, tokenIdsToBurnMpc, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!(pendingBurnState === undefined)) return [3 /*break*/, 4];
                            if (!pendingBurnUuid) {
                                setPendingBurnState(null);
                                return [2 /*return*/];
                            }
                            setServerLoading(true);
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, gqlSdk.BlockchainPendingBurnFindOneWithEmail({
                                    input: { pendingBurnUuid: pendingBurnUuid },
                                })];
                        case 2:
                            blockchainPendingBurnFindOneWithEmail = (_c.sent()).blockchainPendingBurnFindOneWithEmail;
                            if (!blockchainPendingBurnFindOneWithEmail) {
                                setPendingBurnState(null);
                            }
                            else {
                                magicLinkEmail = blockchainPendingBurnFindOneWithEmail.magicLinkEmail, tokenAddress = blockchainPendingBurnFindOneWithEmail.tokenAddress, _a = blockchainPendingBurnFindOneWithEmail.pendingBurn, tokenIdsToBurn = _a.tokenIdsToBurn, tokenIdsBurned_1 = _a.tokenIdsBurned;
                                tokenIdsToBurnMagicLink = tokenIdsToBurn.filter(function (t) { return t.walletType === WalletType.GAME && !tokenIdsBurned_1.map(function (x2) { return x2.id; }).includes(t.id); });
                                tokenIdsToBurnMetamask = tokenIdsToBurn.filter(function (t) { return t.walletType === WalletType.CUSTOM && !tokenIdsBurned_1.map(function (x2) { return x2.id; }).includes(t.id); });
                                tokenIdsToBurnMpc = tokenIdsToBurn.filter(function (t) { return t.walletType === WalletType.MPC && !tokenIdsBurned_1.map(function (x2) { return x2.id; }).includes(t.id); });
                                setPendingBurnState({
                                    magicLinkAddress: (tokenIdsToBurnMagicLink === null || tokenIdsToBurnMagicLink === void 0 ? void 0 : tokenIdsToBurnMagicLink.length) > 0 ? tokenIdsToBurnMagicLink[0].address : '',
                                    magicLinkEmail: magicLinkEmail,
                                    metamaskAddress: (tokenIdsToBurnMetamask === null || tokenIdsToBurnMetamask === void 0 ? void 0 : tokenIdsToBurnMetamask.length) > 0 ? tokenIdsToBurnMetamask[0].address : '',
                                    tokenAddress: tokenAddress,
                                    tokenIdsToBurnMagicLink: tokenIdsToBurnMagicLink.map(function (t) { return t.id; }),
                                    tokenIdsBurnedMagicLink: [],
                                    tokenIdsToBurnMetamask: tokenIdsToBurnMetamask.map(function (t) { return t.id; }),
                                    tokenIdsBurnedMetamask: [],
                                    tokenIdsToBurnMpc: tokenIdsToBurnMpc.map(function (t) { return t.id; }),
                                    tokenIdsBurnedMpc: [],
                                });
                                setPendingBurnStatusMagicLink((tokenIdsToBurnMagicLink === null || tokenIdsToBurnMagicLink === void 0 ? void 0 : tokenIdsToBurnMagicLink.length) > 0 ? EBurnStatus.PENDING : undefined);
                                setPendingBurnStatusMetamask((tokenIdsToBurnMetamask === null || tokenIdsToBurnMetamask === void 0 ? void 0 : tokenIdsToBurnMetamask.length) > 0 ? EBurnStatus.PENDING : undefined);
                                setPendingBurnStatusMpc((tokenIdsToBurnMpc === null || tokenIdsToBurnMpc === void 0 ? void 0 : tokenIdsToBurnMpc.length) > 0 ? EBurnStatus.PENDING : undefined);
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            _b = _c.sent();
                            setPendingBurnState(null);
                            return [3 /*break*/, 4];
                        case 4:
                            setServerLoading(false);
                            return [2 /*return*/];
                    }
                });
            });
        }
        init();
    }, [pendingBurnState, pendingBurnUuid]);
    function burnPendingBurn(connectionType) {
        return __awaiter(this, void 0, void 0, function () {
            var magicLinkAddress, magicLinkEmail, metamaskAddress, tokenIdsToBurnMagicLink, tokenIdsBurnedMagicLink, tokenIdsToBurnMetamask, tokenIdsBurnedMetamask, tokenIdsToBurnMpc, tokenIdsBurnedMpc, address, email, _tokenIdsToBurn, _tokenIdsBurned, chunkSize, chunks, i, error, _i, chunks_1, chunk, err_1, formatedError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!pendingBurnState || serverLoading)
                            return [2 /*return*/];
                        magicLinkAddress = pendingBurnState.magicLinkAddress, magicLinkEmail = pendingBurnState.magicLinkEmail, metamaskAddress = pendingBurnState.metamaskAddress, tokenIdsToBurnMagicLink = pendingBurnState.tokenIdsToBurnMagicLink, tokenIdsBurnedMagicLink = pendingBurnState.tokenIdsBurnedMagicLink, tokenIdsToBurnMetamask = pendingBurnState.tokenIdsToBurnMetamask, tokenIdsBurnedMetamask = pendingBurnState.tokenIdsBurnedMetamask, tokenIdsToBurnMpc = pendingBurnState.tokenIdsToBurnMpc, tokenIdsBurnedMpc = pendingBurnState.tokenIdsBurnedMpc;
                        address = connectionType === WalletConnectionType.MAGIC_LINK ? magicLinkAddress : metamaskAddress;
                        email = connectionType === WalletConnectionType.MAGIC_LINK || connectionType === WalletConnectionType.MPC
                            ? magicLinkEmail
                            : undefined;
                        if (connectionType === WalletConnectionType.MAGIC_LINK) {
                            setPendingBurnStatusMagicLink(EBurnStatus.PROCESSING);
                        }
                        else if (connectionType === WalletConnectionType.METAMASK) {
                            setPendingBurnStatusMetamask(EBurnStatus.PROCESSING);
                        }
                        else {
                            setPendingBurnStatusMpc(EBurnStatus.PROCESSING);
                        }
                        _tokenIdsToBurn = connectionType === WalletConnectionType.MAGIC_LINK
                            ? __spreadArray([], tokenIdsToBurnMagicLink, true) : connectionType === WalletConnectionType.METAMASK
                            ? __spreadArray([], tokenIdsToBurnMetamask, true) : __spreadArray([], tokenIdsToBurnMpc, true);
                        _tokenIdsBurned = connectionType === WalletConnectionType.MAGIC_LINK
                            ? __spreadArray([], tokenIdsBurnedMagicLink, true) : connectionType === WalletConnectionType.METAMASK
                            ? __spreadArray([], tokenIdsBurnedMetamask, true) : __spreadArray([], tokenIdsBurnedMpc, true);
                        chunkSize = 100;
                        chunks = [];
                        for (i = 0; i < _tokenIdsToBurn.length; i += chunkSize) {
                            chunks.push(_tokenIdsToBurn.slice(i, i + chunkSize));
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        _i = 0, chunks_1 = chunks;
                        _a.label = 2;
                    case 2:
                        if (!(_i < chunks_1.length)) return [3 /*break*/, 5];
                        chunk = chunks_1[_i];
                        return [4 /*yield*/, imxActions.transferERC721({
                                toAddress: '0x0000000000000000000000000000000000000000',
                                tokenIds: chunk.map(function (t) { return t.toString(); }),
                                walletFrom: {
                                    address: address,
                                    connectionType: connectionType,
                                    email: email,
                                    magicLinkWalletAddress: (user === null || user === void 0 ? void 0 : user.magicLinkWalletAddress) || undefined,
                                },
                            })];
                    case 3:
                        _a.sent();
                        _tokenIdsBurned.push.apply(_tokenIdsBurned, chunk.map(function (tokenId) { return tokenId; }));
                        if (connectionType === WalletConnectionType.MAGIC_LINK) {
                            setPendingBurnState(__assign(__assign({}, pendingBurnState), { tokenIdsBurnedMagicLink: __spreadArray([], _tokenIdsBurned, true) }));
                        }
                        else if (connectionType === WalletConnectionType.METAMASK) {
                            setPendingBurnState(__assign(__assign({}, pendingBurnState), { tokenIdsBurnedMetamask: __spreadArray([], _tokenIdsBurned, true) }));
                        }
                        else {
                            setPendingBurnState(__assign(__assign({}, pendingBurnState), { tokenIdsBurnedMpc: __spreadArray([], _tokenIdsBurned, true) }));
                        }
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: 
                    // This is the delay needed for our poller to catch up, let's make them wait a little bit more on the web
                    return [4 /*yield*/, sleep(5000)];
                    case 6:
                        // This is the delay needed for our poller to catch up, let's make them wait a little bit more on the web
                        _a.sent();
                        if (connectionType === WalletConnectionType.MAGIC_LINK) {
                            setPendingBurnStatusMagicLink(EBurnStatus.COMPLETED);
                        }
                        else if (connectionType === WalletConnectionType.METAMASK) {
                            setPendingBurnStatusMetamask(EBurnStatus.COMPLETED);
                        }
                        else {
                            setPendingBurnStatusMpc(EBurnStatus.COMPLETED);
                        }
                        return [3 /*break*/, 8];
                    case 7:
                        err_1 = _a.sent();
                        formatedError = err_1;
                        error =
                            formatedError.message && typeof formatedError.message === 'string' && !formatedError.message.includes('[object')
                                ? "".concat(err_1, ".")
                                : t('error.generic');
                        if (connectionType === WalletConnectionType.MAGIC_LINK) {
                            setPendingBurnStatusMagicLink(EBurnStatus.PENDING);
                        }
                        else if (connectionType === WalletConnectionType.METAMASK) {
                            setPendingBurnStatusMetamask(EBurnStatus.PENDING);
                        }
                        else {
                            setPendingBurnStatusMpc(EBurnStatus.PENDING);
                        }
                        console.log("[burnPendingBurn] ".concat(err_1, "."));
                        console.log(JSON.stringify(err_1));
                        return [3 /*break*/, 8];
                    case 8:
                        setDialogProps(error
                            ? {
                                common: {
                                    title: t('common.error'),
                                    close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                                },
                                custom: {
                                    type: DialogType.SIMPLE,
                                    message: error,
                                },
                            }
                            : undefined);
                        return [2 /*return*/];
                }
            });
        });
    }
    return {
        pendingBurnState: pendingBurnState,
        pendingBurnStatusMagicLink: pendingBurnStatusMagicLink,
        pendingBurnStatusMetamask: pendingBurnStatusMetamask,
        pendingBurnStatusMpc: pendingBurnStatusMpc,
        burnPendingBurn: burnPendingBurn,
    };
}
